import queryString from 'query-string'
import { isEmpty, some } from 'lodash/fp'
import qs from 'qs'

import { DEFAULT_PRODUCT_PAGE_SIZE } from 'consts'
import { FILTER_ITEMS } from 'components/Filters/consts'
import { getValidPage } from 'components/Pagination/utils'

export { getValidPage }

export function getUrlParams(
  matchParams,
  locationSearch,
  pageSize = DEFAULT_PRODUCT_PAGE_SIZE,
) {
  const { category, group, subgroup } = matchParams
  const { search, current } = queryString.parse(locationSearch)
  const currentPage = Number(current) > 0 ? Number(current) : 1

  return Object.fromEntries(
    Object.entries({
      current: currentPage,
      search,
      pageSize,
      category,
      group,
      subgroup,
    }).reduce((res, [key, value]) => {
      if (value) return [...res, [key, value]]
      return res
    }, []),
  )
}

export const isAnyFilterSelected = selectedFilters => {
  if (!selectedFilters) return false

  return some(filter => !isEmpty(filter) && !filter[FILTER_ITEMS.ALL])(
    Object.values(selectedFilters),
  )
}

export const stringifyQueryParams = paramsObj =>
  qs.stringify(paramsObj, {
    skipNulls: true,
    sort: (a, b) => a.localeCompare(b),
  })
